<div
  id="back-to-system-overview-header"
  (click)="router.navigate([relativeUrl], { relativeTo: this.route })"
  (keyup.enter)="router.navigate([relativeUrl], { relativeTo: this.route })"
  tabindex="0"
>
  <sh-icon
    class="back-icon"
    icon="arrow-line-left-s"
    aria-label="Back to Overview"
    button
  ></sh-icon>
  <sh-text class="link" size="body-1">Back to System Overview</sh-text>
</div>
